import { Link } from "react-router-dom";
import { Lock, Play } from "lucide-react";

function ThumbFallback({ ep }) {
  return (
    <div className="absolute inset-0 flex items-center justify-center" style={{
      background: "radial-gradient(120% 100% at 0% 0%, rgba(255,0,85,0.25) 0%, rgba(5,5,5,1) 60%), linear-gradient(135deg, #1a0410 0%, #050505 100%)"
    }}>
      <div className="text-center px-4">
        <div className="text-[10px] uppercase tracking-[0.3em] text-brand-primary">S{ep.season} · E{ep.episode_number}</div>
        <div className="font-display text-3xl md:text-4xl uppercase tracking-tight text-white/90 mt-2">{ep.title || "TBA"}</div>
      </div>
    </div>
  );
}

export default function EpisodeCard({ ep, locked = false, index, progressPercent = 0 }) {
  return (
    <Link
      to={`/watch/${ep.id}`}
      data-testid={`episode-card-${ep.id}`}
      className="group relative block overflow-hidden border border-white/10 hover:border-brand-primary/80 transition-all duration-300"
    >
      <div className="aspect-[16/9] overflow-hidden bg-brand-surface relative">
        {ep.thumbnail_url ? (
          <img
            src={ep.thumbnail_url}
            alt={ep.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <ThumbFallback ep={ep} />
        )}
        <div className="absolute inset-0 card-grad" />
        <div className="absolute top-3 left-3 flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-[0.2em] bg-brand-primary text-white px-2 py-1 font-semibold">
            S{ep.season} · E{ep.episode_number}
          </span>
          {locked && (
            <span className="text-[10px] uppercase tracking-[0.2em] bg-black/70 border border-white/20 text-white px-2 py-1 flex items-center gap-1">
              <Lock className="h-3 w-3" /> Premium
            </span>
          )}
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
          <div className="h-14 w-14 rounded-full bg-brand-primary/95 flex items-center justify-center neon-glow">
            <Play className="h-6 w-6 text-white fill-white ml-0.5" />
          </div>
        </div>
        {typeof index === "number" && (
          <div className="absolute -bottom-2 -left-2 font-display text-[110px] leading-none text-white/10 select-none">
            {index + 1}
          </div>
        )}
        {progressPercent > 0 && (
          <div className="absolute bottom-0 left-0 right-0 h-1 bg-white/15">
            <div className="h-full bg-brand-primary" style={{ width: `${Math.min(100, Math.max(2, progressPercent * 100))}%` }} />
          </div>
        )}
      </div>
      <div className="p-4 bg-brand-surface">
        <div className="font-display text-lg uppercase tracking-tight line-clamp-1">{ep.title}</div>
        <div className="text-xs text-brand-muted mt-1 line-clamp-2">{ep.description || "TBA"}</div>
      </div>
    </Link>
  );
}
